import { atom } from "recoil";

const loaderStateAtom = atom({

    key:"loaderState",
    default: false

});

export default loaderStateAtom;